import { ErrorHandler, Inject, Injectable, Injector } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './services/error.service';
import { NotificationService } from './services/notification.service';
import { GuestService } from './services/guest.service';
import { LoggerService } from './services/logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(@Inject(PLATFORM_ID) private platformId: object, private injector: Injector,
    private notificationService: NotificationService, private guestService: GuestService,
    private logger: LoggerService) {
  }

  handleError(error: Error | HttpErrorResponse) {
    const errorService = this.injector.get(ErrorService);
    // const logger = this.injector.get(LoggingService);

    let message;
    // let stackTrace;

    if (error instanceof HttpErrorResponse) {
      // Server error
      //    message = errorService.getServerErrorMessage(error);
      this.notificationService.commonErrorToast();
      //  this.logger.log('Global handler server error', message)
      // stackTrace = errorService.getServerErrorStackTrace(error);
      // notifier.showError(message);

    } else {
      // Client Error
      const chunkFailedMessage = /Loading chunk [\d]+ failed/;
      message = errorService.getClientErrorMessage(error);
      this.logger.log('error!: ', message, error);
      this.guestService.postFrontEndError(message);

      if (chunkFailedMessage.test(message)) {
        if (isPlatformBrowser(this.platformId)) {
          this.guestService.postFrontEndError('mededeling: chunks worden herladen.');
          window.location.reload();
        }
      }

      // notifier.showError(message);
    }
    // Always log errors
    //   console.error('in de global error handler', error);
  }
}
